angular.module('gym.contacts').controller('ConfirmRemoveSuspensionCtrl', ["$scope", "$rootScope", "$state", "$stateParams", "$http", "flash", "contact", "suspension", function($scope, $rootScope, $state, $stateParams, $http, flash, contact, suspension) {
  var generateMembershipChanges, getData, gym;
  $scope.gym = gym = $rootScope.gym;
  $scope.contact = contact;
  $scope.suspension = suspension;
  $scope.visibleBookings = {};
  generateMembershipChanges = function() {
    return $scope.membershipChanges = $scope.memberships.map(function(membership) {
      var bookingIds;
      bookingIds = membership.bookings_affected ? membership.bookings_affected.map(function(item) {
        return item.booking_id;
      }) : void 0;
      return {
        membership_id: membership.membership_id,
        new_expiration_date: membership.new_expiration_date,
        booking_ids_to_delete: bookingIds
      };
    });
  };
  getData = function() {
    var url;
    url = `/gyms/${gym.id}/${$stateParams.contactType}/${contact.id}/suspensions/${suspension.id}/confirm_destroy`;
    return $http.get(url).then(function(response) {
      $scope.memberships = response.data;
      return generateMembershipChanges();
    });
  };
  getData();
  $scope.formatTime = function(time) {
    return moment(time).tz(gym.tz).format('DD MMM YYYY h:mma');
  };
  $scope.isReady = function() {
    if (!$scope.memberships) {
      return false;
    }
    if ($scope.isLoading) {
      return false;
    }
    return _.every($scope.memberships, function(membership, index) {
      return !membership.changes_expected || $scope.membershipChanges[index].remove_bookings_after_expiry !== void 0;
    });
  };
  $scope.goToMember = function() {
    return $state.go('gym.contacts.edit', {
      contactId: contact.id
    });
  };
  return $scope.submit = function() {
    var params, url;
    $scope.errors = void 0;
    $scope.isLoading = true;
    url = `/gyms/${gym.id}/${$stateParams.contactType}/${contact.id}/suspensions/${suspension.id}/destroy_suspension`;
    params = {
      contact_suspension: {
        membership_changes_after_suspension_removal: $scope.membershipChanges
      }
    };
    return $http.put(url, params).then(function() {
      flash.success = "Suspension successfully removed";
      return $scope.goToMember();
    }, function(response) {
      $scope.errors = response.data.errors;
      return $scope.isLoading = false;
    });
  };
}]);
